import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Svg from '../../../components/react/Svg';

const NumericInput = ({
  placeholder,
  name,
  label,
  value,
  maxValue,
  onChange
}) => {
  const inputRef = useRef();
  const handleAdd = () => {
    if (!maxValue || value < maxValue) {
      onChange(value + 1);
    }
  };

  const handleSubstract = () => {
    if (value > 0) {
      onChange(value - 1);
    }
  };

  const handleChange = e => {
    const count = parseInt(e.target.value || 0);

    if (count < 0) {
      onChange(0);
    } else if (maxValue && count > maxValue) {
      onChange(maxValue);
    } else {
      onChange(count);
    }
  };

  const handleFocus = () => {
    inputRef.current.focus();
  };

  return (
    <div className="booking-widget__numeric">
      <div className="booking-widget__numeric-inner">
        <input
          ref={inputRef}
          type="number"
          name={name}
          value={value}
          min={0}
          max={maxValue}
          aria-label={label}
          onChange={handleChange}
        />
        <span
          className="booking-widget__numeric-placeholder"
          onClick={handleFocus}
        >
          {value}
          {placeholder ? ` ${placeholder}` : null}
        </span>
        <div className="booking-widget__numeric-buttons">
          <button
            className="booking-widget__numeric-button"
            type="button"
            onClick={handleAdd}
            disabled={maxValue && value === maxValue}
            aria-label={`Add ${placeholder}`}
          >
            <Svg viewBox="0 0 10 10" name="plus" altText="add"/>

          </button>
          <button
            className="booking-widget__numeric-button"
            type="button"
            onClick={handleSubstract}
            disabled={value === 0}
            aria-label={`Remove ${placeholder}`}
          >
            <Svg viewBox="0 0 10 2" name="minus" altText="remove"/>

          </button>
        </div>
      </div>
    </div>
  );
};

NumericInput.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  maxValue: PropTypes.number,
  onChange: PropTypes.func.isRequired
};

export default NumericInput;
